(()=>{
'use strict';
function init(root){
 if(root.dataset.modulesReady)return;
 root.dataset.modulesReady='true';
 const rail=root.querySelector('.ownership-modules-rail'),arrows=root.querySelector('.ownership-module-arrows'),buttons=[...arrows.querySelectorAll('button')];
 const motion=matchMedia('(prefers-reduced-motion: reduce)');
 let frame=0;
 function update(){
  frame=0;const max=rail.scrollWidth-rail.clientWidth;
  arrows.hidden=max<2;
  buttons[0].disabled=rail.scrollLeft<2;buttons[1].disabled=rail.scrollLeft>max-2;
  const photo=rail.querySelector('.ownership-module-photo');
  if(photo)root.style.setProperty('--module-arrow-y',(photo.getBoundingClientRect().height/2+2)+'px');
 }
 function move(direction){const card=rail.querySelector('.ownership-module');if(!card)return;const step=card.getBoundingClientRect().width+parseFloat(getComputedStyle(rail).gap);rail.scrollBy({left:direction*step,behavior:motion.matches?'instant':'smooth'});}
 buttons.forEach(button=>button.addEventListener('click',()=>move(Number(button.dataset.moduleStep))));
 rail.addEventListener('scroll',()=>{if(!frame)frame=requestAnimationFrame(update);},{passive:true});
 rail.addEventListener('keydown',event=>{if(event.target!==rail)return;if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;event.preventDefault();if(event.key==='Home'||event.key==='End')rail.scrollTo({left:event.key==='Home'?0:rail.scrollWidth,behavior:motion.matches?'instant':'smooth'});else move(event.key==='ArrowLeft'?-1:1);});
 new ResizeObserver(update).observe(rail);update();
}
function scan(scope){scope.querySelectorAll('[data-ownership-modules]').forEach(init);}
scan(document);document.addEventListener('shopify:section:load',event=>scan(event.target));
})();
